import React, { ReactNode } from 'react';
import { Box, BoxProps } from '../../../../wag-react/next-components/box';
type Props = {
  children: ReactNode;
  containerProps?: BoxProps;
};
export const ServiceList = ({
  children,
  containerProps
}: Props) => <Box display="flex" flexDirection="column" borderRadius="12px" overflow="hidden" className="[&>*:nth-child(even)]:bg-[#FAFAFA] [&>*:nth-child(odd)]:bg-white shadow-md" {...containerProps} data-sentry-element="Box" data-sentry-component="ServiceList" data-sentry-source-file="ServiceList.tsx">
    {children}
  </Box>;